import { get } from "lodash";
import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { PropTypes } from "prop-types";
import { Loader, Table } from "semantic-ui-react";

import EstimateControls from "./EstimateControls.jsx";
import FormattedCharge from "./FormattedCharge.jsx";

import scheduleSelector from "../../../state/reducers/schedules/scheduleSelector.js";
import { selectCopy } from "../../../state/reducers/locale/copySelector.js";

class EstimateSummaryView extends PureComponent {
  static propTypes = {
    id: PropTypes.string,
    dimension: PropTypes.string.isRequired,
    isFetching: PropTypes.bool.isRequired,
    estimates: PropTypes.array,
    scheduleNames: PropTypes.object.isRequired,
    showDetails: PropTypes.bool.isRequired,
    handleShowDetails: PropTypes.func.isRequired,
    controlsEnabled: PropTypes.bool.isRequired,
    docked: PropTypes.bool.isRequired,
    copyKey: PropTypes.string.isRequired,
    copy: PropTypes.func.isRequired
  };

  static defaultProps = {
    isFetching: false,
    copyKey: "project_wizard.estimate_panel"
  };

  // -- RENDER -- //

  renderSummaryCells() {
    const { showDetails, estimates, dimension, scheduleNames } = this.props;

    if (!estimates || showDetails) return null;

    return estimates.map(estimate => {
      const chargeData = get(estimate, `total.${dimension}.charge`, null);

      return (
        <Table.Cell textAlign="right" width="2" key={estimate.id}>
          <FormattedCharge chargeData={chargeData} />
          <br />
          <span className="mini-text">{scheduleNames[estimate.id]}</span>
        </Table.Cell>
      );
    });
  }

  render() {
    const { docked, showDetails, isFetching } = this.props;
    return (
      <EstimateControls docked={docked} {...this.props}>
        {isFetching && !showDetails && (
          <Table.Cell textAlign="right">
            <Loader inline active inverted size="small" />
          </Table.Cell>
        )}
        {!isFetching && this.renderSummaryCells()}
      </EstimateControls>
    );
  }
}

const mapStateToProps = state => ({
  scheduleNames: scheduleSelector.selectScheduleNames(state),
  copy: selectCopy(state)
});

export default connect(mapStateToProps)(EstimateSummaryView);
